import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import DiagnosedProfile, { DiagnosedProfileResultError } from './DiagnosedProfileResult';
import { SurveysProfilerError, SurveyNotFound, SurveysProfiler } from './survey';
import { AnswerIsNotAmong, ChoiceIdRequired, ProfilerAnswer, ProfilerAnswerError } from './answer';
import BrickRecommendations, { BrickRecommendationsError } from './brickRecommendations';
class ProfilerAPI extends HundredBricksAPI {
    async getSurveyProfiler() {
        try {
            const { data } = await this.client.get('v2/surveys/profiler');
            return new SurveysProfiler(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                if (error.code === 'SURVEY_NOT_FOUND') {
                    throw new SurveyNotFound({ cause: error });
                }
                else {
                    throw new SurveysProfilerError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new SurveysProfilerError('Unexpected error on surveys profiler', { cause: error });
            }
            else {
                throw new SurveysProfilerError(`Unexpected error on surveys profiler: '${error}'`);
            }
        }
    }
    async getDiagnosedProfileResult() {
        try {
            const { data } = await this.client.get('v2/surveys/profiler/results');
            return new DiagnosedProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                if (error.code === 'PROFILE_DIAGNOSED_NOT_FOUND') {
                    throw new DiagnosedProfileResultError('The user does not have a profile diagnosed', { cause: error });
                }
                else {
                    throw new DiagnosedProfileResultError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new DiagnosedProfileResultError('Unexpected error on diagnosed profile result', { cause: error });
            }
            else {
                throw new DiagnosedProfileResultError(`Unexpected error on diagnosed profile result: '${error}'`);
            }
        }
    }
    async postProfilerAnswer(questionId, answerChoiceId) {
        try {
            const { data } = await this.client.post(`v2/surveys/profiler/question/${questionId}/answer`, { answerChoiceId });
            return new ProfilerAnswer(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'THE_ANSWER_IS_NOT_AMONG_THE_ALLOWED_OPTIONS':
                        throw new AnswerIsNotAmong({ cause: error });
                    case 'ANSWER_CHOICE_ID_IS_REQUIRED':
                        throw new ChoiceIdRequired({ cause: error });
                    default:
                        throw new ProfilerAnswerError({ cause: error });
                }
            }
            if (error instanceof Error) {
                throw new ProfilerAnswerError('Unexpected error on surveys profiler', { cause: error });
            }
            else {
                throw new ProfilerAnswerError(`Unexpected error on profiling answer '${error}'`);
            }
        }
    }
    async getBrickRecommendations() {
        try {
            const { data } = await this.client.get('v2/surveys/profiler/brickRecommendations');
            return new BrickRecommendations(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                if (error.code === 'BRICK_RECOMMENDATIONS_NOT_FOUND') {
                    throw new BrickRecommendationsError('The brick recommendations for the investor is not found', { cause: error });
                }
                else {
                    throw new BrickRecommendationsError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new BrickRecommendationsError('Unexpected error while obtaining brick recommendations for the investor', { cause: error });
            }
            else {
                throw new BrickRecommendationsError(`Unexpected error while obtaining brick recommendations for the investor: '${error}'`);
            }
        }
    }
}
export default ProfilerAPI;
